import React, { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import ButtonGroup from '../../common/components/ButtonGroup';
import { Nullable } from 'common-types';

const CancelScanModal: FC<
  React.PropsWithChildren<CancelScanModalProps>
> = props => {
  const theme = useTheme();
  const { open, onClose, onCancelScan, isLoading, cancelScanErrorMessage } =
    props;

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label='Cancel scan'
      open={open}
      onClose={onClose}
      modalHeader='Cancel scan'>
      <Box flexGrow={1} mb={2}>
        <Typography color={theme.palette.text.primary} variant='body2'>
          Are you sure you want to cancel this running scan ?
        </Typography>
      </Box>
      <Box display='flex' alignItems='end'>
        <ButtonGroup
          onCancel={onClose}
          onClick={onCancelScan}
          isLoading={isLoading}
          buttonCancelLabel={'Continue Scan'}
          buttonCancelTooltip={'Click to continue scan'}
          buttonActionLabel={'Cancel Scan'}
          buttonActionTooltip={'Click to cancel scan'}
          buttonActionColor={'error'}
          isActionDisabled={false}
        />
      </Box>
      {cancelScanErrorMessage && (
        <Box flexGrow={1} mt={1} textAlign='end'>
          <Typography color='error' variant='body2'>
            {cancelScanErrorMessage}
          </Typography>
        </Box>
      )}
    </ModalDialog>
  );
};

interface CancelScanModalProps {
  open: boolean;
  onClose: () => void;
  onCancelScan: () => void;
  isLoading: boolean;
  cancelScanErrorMessage: Nullable<string>;
}

export default CancelScanModal;
